import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
	questionDifficulty: '',
	questionSubject: '',
	questionChapter: '',
	questionSource: '',
	questionType: '',
	questionId: 0
};

const setFilterQuestionDifficulty = (state, action) =>
	updateObject(state, {
		questionDifficulty: action.difficulty
	});

const setFilterQuestionSubject = (state, action) =>
	updateObject(state, { subject: action.subject });

const setFilterQuestionId = (state, action) => updateObject(state, { id: action.id });

const setFilterQuestionChapter = (state, action) =>
	updateObject(state, { chapter: action.chapter });

const setFilterQuestionSource = (state, action) => updateObject(state, { source: action.source });

const setFilterQuestionType = (state, action) => updateObject(state, { type: action.questionType });

const setFilterInitialState = (state) => updateObject(state, initialState);

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_FILTER_INITIAL_STATE:
			return setFilterInitialState(state);
		case actionTypes.SET_FILTER_QUESTION_DIFFICULTY:
			return setFilterQuestionDifficulty(state, action);
		case actionTypes.SET_FILTER_QUESTION_SUBJECT:
			return setFilterQuestionSubject(state, action);
		case actionTypes.SET_FILTER_QUESTION_CHAPTER:
			return setFilterQuestionChapter(state, action);
		case actionTypes.SET_FILTER_QUESTION_ID:
			return setFilterQuestionId(state, action);
		case actionTypes.SET_FILTER_QUESTION_SOURCE:
			return setFilterQuestionSource(state, action);
		case actionTypes.SET_FILTER_QUESTION_TYPE:
			return setFilterQuestionType(state, action);
		default:
			return state;
	}
};

export default reducer;
